IntlMessageFormat.__addLocaleData({"locale":"bo","pluralRuleFunction":function (n,ord){if(ord)return"other";return"other"}});
IntlMessageFormat.__addLocaleData({"locale":"bo-CN","parentLocale":"bo"});
IntlMessageFormat.__addLocaleData({"locale":"bo-IN","parentLocale":"bo"});
